import axios from "../axios-auth";
import orginal_axios from "axios";

export const stockInService = {
    getStockInList,
    getAllStockInList,
    saveStockIn,
    getStockInDetail,
    printStockInInvoice,
    showWindowDialog,
    saveStockInExcel,
    exportStockInExcel,
    exportStockInHeaderDetailExcel,
    getStockInExcelTemplate
};

function getAllStockInList(searchParams) {
    let params = {
        sort: "warehouseName,asc"
    };
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }

    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }

    if (searchParams.serialNo) {
        params["serialNo"] = searchParams.serialNo;
    }

    if (searchParams.poNo) {
        params["poNo"] = searchParams.poNo;
    }

    if (searchParams.type) {
        params["type"] = searchParams.type;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }

    if (searchParams.binIds) {
        params["binIds"] = searchParams.binIds.join();
    }
    return axios.get("/auth/stockins", { params });
}

function getStockInList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }

    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }

    if (searchParams.serialNo) {
        params["serialNo"] = searchParams.serialNo;
    }

    if (searchParams.poNo) {
        params["poNo"] = searchParams.poNo;
    }

    if (searchParams.type) {
        params["type"] = searchParams.type;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }

    if (searchParams.binIds) {
        params["binIds"] = searchParams.binIds.join();
    }

    return axios.get("/auth/stockins", { params });
}

function saveStockIn(stockIn) {
    if (!stockIn.id) {
        // new stockin
        return axios.post("/auth/stockin", stockIn);
    } else {
        // edit
        return axios.put("/auth/stockin", stockIn);
    }
}

function getStockInDetail(id) {
    return axios.get("/auth/stockin/" + id);
}

function printStockInInvoice(id) {
    return orginal_axios({
        url: axios.defaults.baseURL + "/auth/print-stock-in-invoice/" + id,
        method: "GET",
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/pdf",
            "Content-Type": "application/json"
        }
    }).then(function (response) {
        return new Blob([response.data], { type: "application/pdf" });
    });
}

function showWindowDialog(blob, fileName) {
    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob);
        return;
    }

    // For other browsers: 
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(blob);
    var link = document.createElement(fileName);
    link.href = data;
    link.download = fileName + ".pdf";
    window.open(link.href, fileName, "width=500,height=500");

    setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
    }, 100);
}

function saveStockInExcel(file) {
    return axios.post('/auth/stockin-excel',
        file,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    )
}

function exportStockInExcel(id) {
    //return axios.get('/auth/stockin-excel/' + id);
    return orginal_axios({
        url: axios.defaults.baseURL + "/auth/stockin-excel/" + id,
        method: "GET",
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function exportStockInHeaderDetailExcel(searchParams) {
    let params = {
    };
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }

    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }

    if (searchParams.serialNo) {
        params["serialNo"] = searchParams.serialNo;
    }

    if (searchParams.poNo) {
        params["poNo"] = searchParams.poNo;
    }

    if (searchParams.type) {
        params["type"] = searchParams.type;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }

    if (searchParams.binIds) {
        params["binIds"] = searchParams.binIds.join();
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/stock-in-header-detail-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getStockInExcelTemplate(searchParams) {
    let params = {};

    if (searchParams.brandName) {
        params["brandName"] = searchParams.brandName;
    }
    if (searchParams.categoryName) {
        params["categoryName"] = searchParams.categoryName;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/stockin-excel-template",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}